export class Password {
    constructor(public authType: number, public oldPassword?: String, public newPassword?: String,
         public confirmPassword?: String, public userId?: String){}

    toString() {
        return 'old_pw='+this.oldPassword+' new_pw='+this.newPassword + ' confirm_pw='+this.confirmPassword;
    }
}
